import type { Accept } from "react-dropzone";
import type { ResourceFileFormats } from "../actions/pageResources/actions";

// eslint-disable-next-line import/prefer-default-export
export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function transformToAcceptFileFormat(
  oldFormats: Array<ResourceFileFormats>
): Accept {
  const getExtensions = (
    mimeType: ResourceFileFormats
  ): Array<string> => {
    switch (mimeType) {
      case "image/jpeg":
        return [".jpg", ".jpeg"];
      case "image/x-icon":
      case "image/vnd.microsoft.icon":
        return [".icon"];
      default: {
        const subtype = mimeType.split("/")[1] || "";
        const base = subtype.split("+")[0];
        return [`.${base}`];
      }
    }
  };

  return oldFormats.reduce<Accept>((acc: Accept, mime: ResourceFileFormats) => {
    acc[mime] = getExtensions(mime);
    return acc;
  }, {} as Accept);
}
